import { render, staticRenderFns } from "./FollowUpPipelineDesktop.vue?vue&type=template&id=08babda6&scoped=true&"
import script from "./FollowUpPipelineDesktop.vue?vue&type=script&lang=js&"
export * from "./FollowUpPipelineDesktop.vue?vue&type=script&lang=js&"
import style0 from "./FollowUpPipelineDesktop.vue?vue&type=style&index=0&id=08babda6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08babda6",
  null
  
)

export default component.exports